import { IBridgeOptions } from './interface'

/**
 * 是容器事件，仅在原生运行下有效，如离线包 <br>
 * 页面启动，或从后台进入前台显示时触发 <br>
 * 当A视图以打开新容器的方式打开B时，A视图如果监听了 viewAppear 事件，并且B视图关闭重新回到A视图时，此时的A视图的 viewAppear 监听代码会执行 <br>
 * 参考 http://document.lightyy.com/zh-cn/api/olight-event.html#viewappear
 *
 * @param {IBridgeOptions} { success, fail, complete }
 */
function viewAppearSync({ success, fail, complete }: IBridgeOptions) {
  if (window.LightJSBridge) {
    window.LightJSBridge.onPageAppear = () => {
      success && success()
      complete && complete()
    }
  } else {
    fail && fail()
    complete && complete()
  }
}

/**
 * 是容器事件，仅在原生运行下有效，如离线包 <br>
 * 页面启动，或从后台进入前台显示时触发 <br>
 * 当A视图以打开新容器的方式打开B时，A视图如果监听了 viewAppear 事件，并且B视图关闭重新回到A视图时，此时的A视图的 viewAppear 监听代码会执行 <br>
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function viewAppear() {
  return new Promise((resolve, reject) => {
    if (window.LightJSBridge) {
      window.LightJSBridge.onPageAppear = () => {
        resolve()
      }
    } else {
      reject('window.LightJSBridge 对象不存在')
    }
  })
}

export { viewAppearSync }
